export default "__VITE_ASSET__XMpBgzou__"